import { AUTHENTICATION_V2_ENDPOINT } from '@dtx-company/true-common/src/constants/endpoints'
import { IthacaJwt } from '@dtx-company/ithaca-sdk/src'
import { useAuthState } from '@dtx-company/inter-app/src/hooks/useAuthState'
import React, { useEffect } from 'react'

interface UseSeatCountType {
  seatCount: number | undefined
  userCount: number | undefined
}

const url = AUTHENTICATION_V2_ENDPOINT + '/org-member-count'

export const getSeatCount = async (jwt: IthacaJwt): Promise<UseSeatCountType> => {
  const { token } = jwt

  if (!token) {
    throw new Error('Unable to fetch org, no token found')
  }
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      authorization: `Bearer ${token}`,
      Accept: 'application/json'
    }
  })
  const orgResponse = await response.json()
  if (orgResponse.status < 200 || orgResponse.status >= 300)
    throw new Error(`Org fetch failed with status ${orgResponse.status}`)
  return { seatCount: orgResponse.seatCount, userCount: orgResponse.userCount }
}

export const useSeatCount = (): UseSeatCountType => {
  const [seatCount, setSeatCount] = React.useState<number | undefined>(undefined)
  const [userCount, setUserCount] = React.useState<number | undefined>(undefined)
  const { jwt } = useAuthState()
  useEffect(() => {
    if (jwt && jwt?.org) {
      getSeatCount(jwt)
        .then(orgCounts => {
          setUserCount(orgCounts.userCount)
          setSeatCount(orgCounts.seatCount)
        })
        .catch(e => {
          console.info(`Error fetching seat count, ${e.message}`)
        })
    }
  }, [jwt])

  return { seatCount, userCount }
}
